module.exports = __webpack_public_path__ + "img/07-title.47fcf679.png";